import React from "react";
import { Bar } from "react-chartjs-2";

const getFillAnnotation = (color, from, to) => {
  return {
    type: "box",
    backgroundColor: color,
    borderWidth: 0,
    xMax: to,
    xMin: from,
  };
};
export default function YearToYearMachinesSalesBar({
  dataset1,
  dataset2,
  labels,
  firstBarKey,
  secondBarKey,
  datasetCount1,
  datasetCount2,
}) {
  const datasets = [];
  datasets.push({
    label: firstBarKey || null,
    data: dataset1,
    backgroundColor: "#C5D8FF",
    countData: datasetCount1,
    borderRadius: { topRight: 5, topLeft: 5 },
    borderSkipped: false,
  });
  if (secondBarKey) {
    datasets.push({
      label: secondBarKey || null,
      data: dataset2,
      backgroundColor: "#0140BE",
      countData: datasetCount2,
      borderRadius: { topRight: 5, topLeft: 5 },
      borderSkipped: false,
    });
  }

  const chartData = {
    labels: labels,
    datasets,
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 4, 
    plugins: {
      title: {
        display: false,
        text: "Sprzedaż rok do roku",
      },
      tooltip: {
        mode: "index",
        intersect: false,
        enabled: true,
        callbacks: {
          label: (ctx) => {
            const dataset = ctx.chart.data.datasets[ctx.datasetIndex];
            const price = ctx.raw;
            const countData = dataset.countData;
            if (!price || isNaN(price)) {
              return `${dataset.label}: -`;
            }
            if (!countData) {
              return `${dataset.label}: ${new Intl.NumberFormat("pl-PL", {
                style: "currency",
                currency: "PLN",
              }).format(price)} zł`;
            }

            const count = countData[ctx.dataIndex] || 0;
            return `${dataset.label}: ${new Intl.NumberFormat("pl-PL", {
              style: "currency",
              currency: "PLN",
            }).format(price)}  (${count} szt.)`;
          },
        },
      },
      annotation: {
        drawTime: "beforeDraw",
        annotations: {
          annotation1: getFillAnnotation(
            "rgba(159,168,218,0.2)",
            -0.5,
            2.5,
            "Pierwsza kwartał"
          ),
          annotation2: getFillAnnotation(
            "rgba(188,170,164,0.2)",
            2.5,
            5.5,
            "Druga kwartał"
          ),
          annotation3: getFillAnnotation(
            "rgba(165,214,167,0.2)",
            5.5,
            8.5,
            "Trzeci kwartał"
          ),
          annotation4: getFillAnnotation(
            "rgba(159,168,218,0.2)",
            8.5,
            12,
            "Czwarty kwartał"
          ),
        },
      },
    },
  };

  return <Bar data={chartData} options={options} />
}
